import { TGeoPoint } from "./base";
import { TReference, TRelative } from "./common/relative";

export const TReferenceToStringConverter = TReference.transform(
  (data) => data.path
);

export const TRelativeToStringConverter = TRelative.transform((data) => {
  return {
    ...data,
    reference:
      typeof data.reference === "string"
        ? data.reference
        : data.reference?.path,
  };
});

export const TGeoPointToNumberArrayConverter = TGeoPoint.transform((data) => {
  return [data.latitude, data.longitude];
});
